import { useQuery } from '@apollo/client'
import moment from 'moment'
import React, { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { SkyButton } from '../../Components/Buttons'
import { GET_DRIVERS_BY_FLEET_OWNER } from '../../Services/cabapi/fleetggl'
import { MyContext } from '../../utils/context/TempAuth'

const ManageDriver = () => {
  const navigate = useNavigate()
  const { userData } = useContext(MyContext)
  const { loading, error, data, refetch } = useQuery(
    GET_DRIVERS_BY_FLEET_OWNER,
    {
      variables: {
        fleetOwnerId: userData?.fleetId,
      },
    }
  )
  useEffect(() => {
    refetch()
  }, [])
  if (loading) {
    return <div>Loading...</div>
  }
  if (error) {
    return <div>Error: {error.message}</div>
  }
  return (
    <div>
      <div className="w-full  h-full bg-white p-4 shadow rounded-md text-start">
        <div className="sticky top-0">
          <div className="text-stone-500 text-xl font-bold mb-4">
            Manage Driver
          </div>
          <div className="my-3 flex justify-end">
            <SkyButton
              label={'Add Driver'}
              onClick={() => navigate('add-driver')}
            />
          </div>
          <div className="mt-4 w-full overflow-x-auto h-[70vh]">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 border-collapse border border-gray-300">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 sticky top-0 z-10">
                <tr>
                  <th className="px-6 py-3 border border-gray-300">Name</th>
                  <th className="px-6 py-3 border border-gray-300">
                    Mobile Number
                  </th>
                  <th className="px-6 py-3 border border-gray-300">Email</th>
                  <th className="px-6 py-3 border border-gray-300">
                    Permanent Address
                  </th>
                  <th className="px-6 py-3 border border-gray-300">
                    Birthdate
                  </th>
                  <th className="px-6 py-3 border border-gray-300">
                    Tr Expiry
                  </th>
                  <th className="px-6 py-3 border border-gray-300">Menu</th>
                  <th className="px-6 py-3 border border-gray-300">Verify</th>
                </tr>
              </thead>
              <tbody>
                {data?.getDriverByFleetOwner?.map((items, index) => (
                  <tr className="bg-white border-b" key={index}>
                    <td className="px-6 py-4 border border-gray-300">
                      {items?.firstName} {items?.middleName} {items?.lastName}
                    </td>
                    <td className="px-6 py-4 border border-gray-300">
                      {items?.mobileNumber}
                    </td>
                    <td className="px-6 py-4 border border-gray-300">
                      {items?.email}
                    </td>

                    <td className="px-6 py-4 border border-gray-300">
                      {items?.permanentAddress}
                    </td>
                    <td className="px-6 py-4 border border-gray-300">
                      {moment(items?.birthDate).format('MMM DD YYYY')}
                    </td>
                    <td className="px-6 py-4 border border-gray-300">
                      {moment(items?.trDate).format('MMM DD YYYY')}
                    </td>
                    <td className="px-6 py-4 border border-gray-300">
                      <SkyButton
                        label={'Edit'}
                        onClick={() => {
                          navigate('/manage-driver/edit-driver', {
                            state: items,
                          })
                        }}
                      />
                    </td>
                    <td className="px-6 py-4 border border-gray-300">
                      {items?.isVerified ? 'Verified' : 'Un-Verified'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ManageDriver
